import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import App from './App';

// Load only required locales - should match Resources locales
import 'moment/locale/en-gb';
import 'moment/locale/en-au';
import 'moment/locale/bg';
import 'moment/locale/ru';
import 'moment/locale/de';

import '../theme/css/bootstrap.min.css';
import '../theme/css/font-awesome.min.css';
import '../theme/css/custom.css';

const store = configureStore();

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>
	, document.getElementById('root'));